import styled from 'styled-components';
import { theme } from '_constants/theme';
import { FAQ } from '_constants/faq';
import Accordion from './Accordion';

const { colors, devices, fontSizes, spaces } = theme;

const StyledFAQ = styled.div`
  margin-left: auto;
  margin-right: auto;

  h1 {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.large11X}px;
    line-height: 130%;
    text-align: center;
    color: ${colors.gray[800]};
  }

  .faqContainer {
    width: 770px;
    margin-top: 60px;
    background: ${colors.white};
    box-shadow: 0px 30px 80px rgba(0, 0, 0, 0.05);
    border-radius: 40px;
    .accordion {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      padding: ${spaces.large4X}px;
      gap: ${spaces.regular}px;
    }
  }

  @media ${devices.tablet} {
    width: 100%;
    padding-left: ${spaces.regular}px;
    padding-right: ${spaces.regular}px;
    h1 {
      font-size: ${fontSizes.large2X}px;
    }
    .faqContainer {
      width: 100%;
      margin-top: ${spaces.large}px;
      padding: 0px;
      box-shadow: none;
      .accordion {
        padding: 0px;
        gap: 10px;
      }
    }
  }
`;

const FAQSection = ({ items }) => {
  return (
    <StyledFAQ>
      <h1>FAQs</h1>
      <div className="faqContainer">
        <Accordion faqList items={items ? items : FAQ[0].items} />
      </div>
    </StyledFAQ>
  );
};

export default FAQSection;
